import { render, staticRenderFns } from "./VuesticFileUpload.vue?vue&type=template&id=3a1f6cca"
import script from "./VuesticFileUpload.vue?vue&type=script&lang=js"
export * from "./VuesticFileUpload.vue?vue&type=script&lang=js"
import style0 from "./VuesticFileUpload.vue?vue&type=style&index=0&id=3a1f6cca&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a1f6cca')) {
      api.createRecord('3a1f6cca', component.options)
    } else {
      api.reload('3a1f6cca', component.options)
    }
    module.hot.accept("./VuesticFileUpload.vue?vue&type=template&id=3a1f6cca", function () {
      api.rerender('3a1f6cca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-file-upload-kyc/VuesticFileUpload.vue"
export default component.exports